"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseNursysTransactionDto = instanceOfNurseNursysTransactionDto;
exports.NurseNursysTransactionDtoFromJSON = NurseNursysTransactionDtoFromJSON;
exports.NurseNursysTransactionDtoFromJSONTyped = NurseNursysTransactionDtoFromJSONTyped;
exports.NurseNursysTransactionDtoToJSON = NurseNursysTransactionDtoToJSON;
exports.NurseNursysTransactionDtoToJSONTyped = NurseNursysTransactionDtoToJSONTyped;
/**
 * Check if a given object implements the NurseNursysTransactionDto interface.
 */
function instanceOfNurseNursysTransactionDto(value) {
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('messages' in value) || value['messages'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    if (!('jurisdiction' in value) || value['jurisdiction'] === undefined)
        return false;
    if (!('compactStatus' in value) || value['compactStatus'] === undefined)
        return false;
    if (!('licenseNumber' in value) || value['licenseNumber'] === undefined)
        return false;
    if (!('licenseStatus' in value) || value['licenseStatus'] === undefined)
        return false;
    if (!('licenseExpirationDate' in value) || value['licenseExpirationDate'] === undefined)
        return false;
    if (!('nurseLookupDisciplines' in value) || value['nurseLookupDisciplines'] === undefined)
        return false;
    if (!('jurisdictionAbbreviation' in value) || value['jurisdictionAbbreviation'] === undefined)
        return false;
    if (!('licenseOriginalIssueDate' in value) || value['licenseOriginalIssueDate'] === undefined)
        return false;
    if (!('nurseLookupNotifications' in value) || value['nurseLookupNotifications'] === undefined)
        return false;
    if (!('nurseLookupAdvancedPractices' in value) || value['nurseLookupAdvancedPractices'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('processedAt' in value) || value['processedAt'] === undefined)
        return false;
    return true;
}
function NurseNursysTransactionDtoFromJSON(json) {
    return NurseNursysTransactionDtoFromJSONTyped(json, false);
}
function NurseNursysTransactionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'active': json['active'],
        'lastName': json['lastName'],
        'messages': json['messages'],
        'firstName': json['firstName'],
        'licenseType': json['licenseType'],
        'jurisdiction': json['jurisdiction'],
        'compactStatus': json['compactStatus'],
        'licenseNumber': json['licenseNumber'],
        'licenseStatus': json['licenseStatus'],
        'licenseExpirationDate': json['licenseExpirationDate'],
        'nurseLookupDisciplines': json['nurseLookupDisciplines'],
        'jurisdictionAbbreviation': json['jurisdictionAbbreviation'],
        'licenseOriginalIssueDate': json['licenseOriginalIssueDate'],
        'nurseLookupNotifications': json['nurseLookupNotifications'],
        'nurseLookupAdvancedPractices': json['nurseLookupAdvancedPractices'],
        'createdAt': (new Date(json['createdAt'])),
        'processedAt': (json['processedAt'] == null ? null : new Date(json['processedAt'])),
    };
}
function NurseNursysTransactionDtoToJSON(json) {
    return NurseNursysTransactionDtoToJSONTyped(json, false);
}
function NurseNursysTransactionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'active': value['active'],
        'lastName': value['lastName'],
        'messages': value['messages'],
        'firstName': value['firstName'],
        'licenseType': value['licenseType'],
        'jurisdiction': value['jurisdiction'],
        'compactStatus': value['compactStatus'],
        'licenseNumber': value['licenseNumber'],
        'licenseStatus': value['licenseStatus'],
        'licenseExpirationDate': value['licenseExpirationDate'],
        'nurseLookupDisciplines': value['nurseLookupDisciplines'],
        'jurisdictionAbbreviation': value['jurisdictionAbbreviation'],
        'licenseOriginalIssueDate': value['licenseOriginalIssueDate'],
        'nurseLookupNotifications': value['nurseLookupNotifications'],
        'nurseLookupAdvancedPractices': value['nurseLookupAdvancedPractices'],
        'createdAt': ((value['createdAt']).toISOString()),
        'processedAt': (value['processedAt'] == null ? null : value['processedAt'].toISOString()),
    };
}
//# sourceMappingURL=NurseNursysTransactionDto.js.map